import  gql  from 'graphql-tag'

export const SET_PASSWORD = gql`mutation setPassword($input: SetPasswordMutationInput!){
    setPassword(input: $input){
        errors{
            field
            messages
        }
    }
}`;